import { css } from "../../../../../styled-system/css";

export const styles = {
  contentWrapper: (withImage: boolean) =>
    css({
      maxWidth: "528px",
      desktop: {
        maxWidth: withImage ? "528px" : "712px",
      },
      "& h2": {
        marginTop: 0,
      },
    }),

  textWrapper: (title: string | undefined) =>
    css({
      color: "headlineGrey",
      fontSize: "body.cat",
      lineHeight: "body.cat",
      marginTop: title ? "0" : "baseUnit.mobile3",
      desktop: {
        marginTop: 0,
        fontSize: "body.horse",
        lineHeight: "body.horse",
      },
      "& a": {
        fontSize: "inherit",
        lineHeight: "inherit",
        textDecoration: "underline",
      },
    }),

  buttonWrapper: () =>
    css({
      textAlign: "center",
      paddingTop: "baseUnit.mobile3",
    }),
};
